import AboutUs from '@pages/admin/all-pages/about-us'
import PrivacyPolicy from '@pages/admin/all-pages/privacy-policy'
import TermsAndConditions from '@pages/admin/all-pages/terms-and-conditions'

import BannerSettings from '@pages/admin/banner-settings'
import Dashboard from '@pages/admin/dashboard'
import AdminList from '@pages/admin/dashboard/admin-list'
import ConditionalEvents from '@pages/admin/game-management/conditional-events'

import MatchResults from '@pages/admin/game-management/match-results'
import MatchRooms from '@pages/admin/game-management/match-rooms'
import CreateMatchRoom from '@pages/admin/game-management/match-rooms/admin-created/create-matchroom'
import RulesOfGames from '@pages/admin/game-management/rules-of-games'
import MaintainanceMode from '@pages/admin/maintainance-mode'
import Maintainance from '@pages/admin/maintainance-mode'
import NotificationList from '@pages/admin/notifications'
import Notification from '@pages/admin/notifications'
import LoadWallet from '@pages/admin/payment/load-wallet'
import PaymentSettings from '@pages/admin/payment/settings'
import Withdraw from '@pages/admin/payment/withdraw'
import PushNotifications from '@pages/admin/push-notifications'
import IssueTitle from '@pages/admin/settings/issue-title/page'
import Role from '@pages/admin/settings/role'
import Category from '@pages/admin/store-management/category'
import GameTopUps from '@pages/admin/store-management/game-top-ups'
import GameTopUpOrderHistory from '@pages/admin/store-management/game-top-up-orders'
import Order from '@pages/admin/store-management/order'
import Product from '@pages/admin/store-management/product'
import CreateProduct from '@pages/admin/store-management/product/create-product'
import SmmServices from '@pages/admin/store-management/smm-services'
import SmmOrderHistory from '@pages/admin/store-management/smm-orders'
import SupportTickets from '@pages/admin/support-tickets'
import UserManagement from '@pages/admin/user-management'
import IndividualUser from '@pages/admin/user-management/individual-user'
export const adminRoutes = [
  {
    path: 'dashboard',
    Component: Dashboard,
    exact: true,
  },
  {
    path: 'dashboard/home',
    Component: Dashboard,
    exact: true,
  },
  {
    path: 'dashboard/admin-list',
    Component: AdminList,
    exact: true,
  },
  {
    path: 'user-management',
    Component: UserManagement,
    exact: true,
  },
  {
    path: 'user-management/:userId',
    Component: IndividualUser,
    exact: true,
  },
  {
    path: 'game-management/match-rooms',
    Component: MatchRooms,
    exact: true,
  },
  {
    path: 'game-management/match-rooms/create-matchroom',
    Component: CreateMatchRoom,
    exact: true,
  },
  {
    path: 'game-management/match-rooms/create-matchroom/:id',
    Component: CreateMatchRoom,
    exact: true,
  },
  {
    path: 'game-management/match-results',
    Component: MatchResults,
    exact: true,
  },
  {
    path: 'game-management/rules',
    Component: RulesOfGames,
    exact: true,
  },
  {
    path: 'game-management/conditional-events',
    Component: ConditionalEvents,
    exact: true,
  },
  {
    path: 'game-management/conditional-events/:id',
    Component: ConditionalEvents,
    exact: true,
  },
  {
    path: 'store-management/category',
    Component: Category,
    exact: true,
  },
  {
    path: 'store-management/category/:id',
    Component: Category,
    exact: true,
  },
  {
    path: 'store-management/product',
    Component: Product,
    exact: true,
  },
  {
    path: 'store-management/product/create-product',
    Component: CreateProduct,
    exact: true,
  },
  {
    path: 'store-management/product/update-product/:id',
    Component: CreateProduct,
    exact: true,
  },
  {
    path: 'store-management/order',
    Component: Order,
    exact: true,
  },
  {
    path: 'store-management/smm-services',
    Component: SmmServices,
    exact: true,
  },
  {
    path: 'store-management/game-top-ups',
    Component: GameTopUps,
    exact: true,
  },
  {
    path: 'store-management/smm-orders',
    Component: SmmOrderHistory,
    exact: true,
  },
  {
    path: 'store-management/game-top-up-orders',
    Component: GameTopUpOrderHistory,
    exact: true,
  },
  {
    path: 'payment/load-wallet',
    Component: LoadWallet,
    exact: true,
  },
  {
    path: 'payment/withdraw',
    Component: Withdraw,
    exact: true,
  },
  {
    path: 'payment/settings',
    Component: PaymentSettings,
    exact: true,
  },
  {
    path: 'push-notifications',
    Component: PushNotifications,
    exact: true,
  },
  {
    path: 'push-notifications/:id',
    Component: PushNotifications,
    exact: true,
  },
  {
    path: 'support-tickets',
    Component: SupportTickets,
    exact: true,
  },
  {
    path: 'banner-settings',
    Component: BannerSettings,
    exact: true,
  },
  {
    path: 'banner-settings/:id',
    Component: BannerSettings,
    exact: true,
  },
  {
    path: 'maintainance-mode',
    Component: MaintainanceMode,
    exact: true,
  },
  {
    path: 'all-pages/privacy-policy',
    Component: PrivacyPolicy,
    exact: true,
  },
  {
    path: 'all-pages/about-us',
    Component: AboutUs,
    exact: true,
  },
  {
    path: 'all-pages/termsandconditions',
    Component: TermsAndConditions,
    exact: true,
  },
  {
    path: 'settings/role',
    Component: Role,
    exact: true,
  },
  {
    path: 'settings/issue-title',
    Component: IssueTitle,
    exact: true,
  },
  {
    path: 'notifications',
    Component: NotificationList,
    exact: true,
  },
]
